

import { uploadFile, put, get } from './commonFetch';
import { AccountOrgNodes } from '../types/account';

export const uploadPreviewBrandingImage = (file: File): Promise<any> => {
  return uploadFile('/api/account/settings/previewBrandingImage', file);
};

export const setBrandingImage = (brandingImageId: string): Promise<any> => {
  return put(`/api/account/settings/brandingImage/${brandingImageId}`, {});
}; 

export const getAccountOrgNodes = (): Promise<AccountOrgNodes> => {
  return get('/api/accounts/orgs');
};
